import { create } from "zustand";
import { UserAdminInfo, UserResource } from "../api/users";

interface UsersState {
  users: UserAdminInfo[];
  nextToken?: string;
  loading: boolean;
  error: string | null;
  emailFilter?: string;
  rcStoreFilter?: string;
  rcStatusFilter?: string;
  loadUsers: (filter?: string, rcStore?: string, rcStatus?: string) => Promise<void>;
  loadNextPage: () => Promise<void>;
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: [],
  nextToken: undefined,
  loading: false,
  error: null,
  emailFilter: undefined,
  rcStoreFilter: undefined,
  rcStatusFilter: undefined,

  loadUsers: async (filter?: string, rcStore?: string, rcStatus?: string) => {
    set({ loading: true, error: null, emailFilter: filter, rcStoreFilter: rcStore, rcStatusFilter: rcStatus });
    try {
      if (rcStore || rcStatus) {
        const response = await UserResource.getUsersByRcProvider({ store: rcStore, status: rcStatus, filter });
        set({ users: response.users, nextToken: response.nextToken, loading: false });
      } else {
        const response = await UserResource.getList({ filter });
        set({ users: response.users, nextToken: response.nextToken, loading: false });
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load users";
      set({ error, loading: false });
    }
  },

  loadNextPage: async () => {
    const { nextToken, emailFilter, rcStoreFilter, rcStatusFilter, users } = get();
    if (!nextToken) return;
    set({ loading: true });
    try {
      if (rcStoreFilter || rcStatusFilter) {
        const response = await UserResource.getUsersByRcProvider({ store: rcStoreFilter, status: rcStatusFilter, filter: emailFilter, nextToken });
        set({ users: [...users, ...response.users], nextToken: response.nextToken, loading: false });
      } else {
        const response = await UserResource.getList({ filter: emailFilter, nextToken });
        set({ users: [...users, ...response.users], nextToken: response.nextToken, loading: false });
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load more users";
      set({ error, loading: false });
    }
  },
}));
